import { useQuery } from '@tanstack/react-query';
import { getNotes } from '../api';
import { NoteFilter } from '../types/note';

const ITEMS_PER_PAGE = 12;

export interface UseNotesOptions {
  filter: NoteFilter;
  page: number;
}

export function useNotes({ filter, page }: UseNotesOptions) {
  const skip = (page - 1) * ITEMS_PER_PAGE;
  
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['notes', { ...filter, skip }],
    queryFn: async () => {
      const response = await getNotes({
        ...filter,
        skip,
        limit: ITEMS_PER_PAGE
      });
      return {
        items: response.items,
        totalPages: Math.max(1, Math.ceil(response.total / ITEMS_PER_PAGE))
      };
    },
    staleTime: 30 * 1000, // Consider data fresh for 30 seconds
  });

  return {
    notes: data?.items ?? [],
    totalPages: data?.totalPages ?? 1,
    isLoading,
    error,
    refetch
  };
}
